import { LicenseIcon } from './LicenseIcon';

/**
 * author: Google
 * id 8398466C-F905-444F-81E6-B5B2103BD873
 * name license
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/license.svg
 * tags
 */
export const AwardIcon = LicenseIcon;
export default AwardIcon